<template>
  <div>
    <b-table striped :items="calendarEvents" small :fields="calendarFields" :busy="calendarLoading">
      <template #thead-top="">
        <b-tr>
            <b-th colspan="2"><h5><b-link v-b-modal.calendarModal>Schedule</b-link></h5></b-th>
        </b-tr>
      </template>

      <template #cell(start)="data">
        <span>{{ moment(data.value).format('MMMM Do, YYYY') }}</span>
      </template>

      <template #cell(title)="data">
        <span>{{ data.value }}</span>
      </template>

      <template #table-busy>
      <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="mx-3">Loading...</strong>
      </div>
      </template>
    </b-table>
      
    <b-modal id="calendarModal"
             title="Calendar"
             size="xl"
             scrollable
             button-size="sm"
             hide-footer
             hide-header
             centered
             @ok="closeCalendar"
             @hide="closeCalendar">
      <calendar></calendar>
    </b-modal>
  </div>
</template>

<script>
  import moment from "moment";
  import calendarApi from "@/api/calendar";
  import Calendar from "@/components/employees/Calendar";
  import utils from "@/mixins/utils";

  export default {
    name: 'Schedule',
    mixins: [ calendarApi, utils ],
    components: {
      Calendar,
    },
    props: [ 'from', 'to', 'refresh' ],
    data() {
      return {
        calendarEvents: [],
        calendarFields: [
          { key: 'start', label: 'Date'  },
          { key: 'username', label: 'User' },
          { key: 'title', label: 'Entry'  },
        ],
        calendarLoading: false,
      }
    },
    methods: {
      closeCalendar() {
        this.getStats();
      },
      async getStats() {
        this.calendarLoading = true;

        try {
          let from = moment(this.from).startOf('month').format('YYYY-MM-DD').toString();
          let to = moment(this.from).endOf('month').format('YYYY-MM-DD').toString();

          const calendarEvents = await this.getEvents(from, to);

          this.calendarEvents = calendarEvents.map(event => {
            let date = event.start ? moment(event.start) : moment();
                
            if (date.isSame(this.from, 'day') || date.isBetween(this.from, moment(this.to).add(1, 'day'))) {
              return event;
            }
          }).filter(Boolean);
        } catch (err) {
          this.showError(err, 'Schedule');
        } finally {
          this.calendarLoading = false;
        }
      },
    },
    watch: {
      from() {
        this.getStats();
      },
      to() {
        this.getStats();
      },
      refresh() {
        this.getStats();
      }
    }
  }
</script>

<style scoped>
  .table thead tr:first-child th {
    border-top: 0;
  }
</style>